import { Stack } from '@ui-components/neo.tax';
import { ReactNode } from 'react';

export const DataSourceSection = ({
  actions,
  children,
  title,
}: {
  /** Names the section for assistive technology; the tab above it already shows the name. */
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}): JSX.Element => (
  <Stack as="section" direction="column" gap={3} fullWidth className="shrink-0" aria-label={title}>
    {actions ? (
      <Stack justifyContent="end" gap={3} wrap="wrap" fullWidth>
        {actions}
      </Stack>
    ) : (
      <></>
    )}
    {children}
  </Stack>
);
